
import React from 'react';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';

const WeatherAlerts = ({ isSnowExpected, isRainExpected, forecastHours = 0, alertForecastHours = 6, windSpeed }) => {

  const getTimeText = () => {
    if (forecastHours === -24) return 'yesterday';
    if (forecastHours === 0) return 'Upcoming';
    return 'In';
  };

  const hasAlerts = isSnowExpected || isRainExpected || windSpeed > 20;
  if (!hasAlerts) return null;

  return (
    <div className="space-y-2 animate-fade-in motion-reduce:animate-none">
      <div className="flex items-center flex-wrap gap-2 text-sm text-gray-700 dark:text-gray-300">
        <span className="font-medium">
          {getTimeText()} {forecastHours !== -24 && `${alertForecastHours} hours`} •
        </span>
        <div className="flex flex-wrap gap-2">
          {isSnowExpected && (
            <Badge 
              variant="secondary"
              className={cn(
                "bg-gradient-to-r from-purple-100 to-purple-200 dark:from-purple-900/40 dark:to-purple-800/40",
                "text-purple-700 dark:text-purple-300 hover:from-purple-200 hover:to-purple-300",
                "dark:hover:from-purple-900/60 dark:hover:to-purple-800/60 transition-colors"
              )}
            >
              Snow <span className="ml-1" role="img" aria-label="snow">🌨️</span>
            </Badge>
          )}
          {isRainExpected && (
            <Badge 
              variant="secondary"
              className={cn(
                "bg-gradient-to-r from-purple-100 to-purple-200 dark:from-purple-900/40 dark:to-purple-800/40",
                "text-purple-700 dark:text-purple-300 hover:from-purple-200 hover:to-purple-300",
                "dark:hover:from-purple-900/60 dark:hover:to-purple-800/60 transition-colors"
              )}
            >
              Rain <span className="ml-1" role="img" aria-label="rain">☔</span>
            </Badge>
          )}
          {windSpeed > 20 && (
            <Badge 
              variant="secondary"
              className={cn(
                "bg-gradient-to-r from-purple-100 to-purple-200 dark:from-purple-900/40 dark:to-purple-800/40",
                "text-purple-700 dark:text-purple-300 hover:from-purple-200 hover:to-purple-300",
                "dark:hover:from-purple-900/60 dark:hover:to-purple-800/60 transition-colors"
              )}
            >
              Windy <span className="ml-1" role="img" aria-label="wind">🌬️</span>
            </Badge>
          )}
        </div>
      </div>
      {isRainExpected && (
        <p className="text-sm text-blue-600 dark:text-blue-400 font-medium animate-fade-in motion-reduce:animate-none">
          Don't forget your umbrella!
        </p>
      )}
    </div>
  );
};

export default WeatherAlerts;
